import Vue from 'vue'
import Vuex from 'vuex'
import CF from '../../static/config.json'

Vue.use(Vuex)

const state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false,
  URLHost: CF.api_url,
  URLBase: CF.ui_url,
  Keypublic: CF.key_public,
  data_sidebartype: 'full',
  menu_data: []
}

const store = new Vuex.Store({
  state
})

export default store



// WEBPACK FOOTER //
// ./src/Vuex/index.js